export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false,
};

export const PageName = '团队签到配置';
